import FormWrapper from 'components/Form/FormWrapper'
import styled from 'styled-components'
import HistoryTable from './components/HistoryTable'
import FilterForm from './components/FilterForm'
import { useCallback, useEffect, useState } from 'react'
import { orderService } from 'services'
import { useLocation, useHistory } from 'react-router-dom'
import * as qs from 'query-string'

const WrapperPage = styled.div`
  min-height: 77vh;
  width: 100%;
  padding: 0 20px 40px;
`

const Page = () => {
  const location = useLocation()
  const history = useHistory()
  const [dataList, setDataList] = useState<any>()
  const [loadingList, setLoadingList] = useState<boolean>(true)
  const [loadingSearch, setLoadingSearch] = useState<boolean>(false)
  const [params, setParams] = useState<any>()
  const [listSelectedOrder, setListSelectedOrder] = useState<any[]>([])

  useEffect(() => {
    const base: any = {
      page: 1,
      per_page: 25,
    }
    const queryObject = qs.parse(location.search)
    if (queryObject?.page === undefined) {
      setParams({ ...base, ...queryObject })
    } else {
      setParams(queryObject)
    }

  }, [])

  useEffect(() => {
    if (params) {
      history.replace(`/theo-doi-don-van?${qs.stringify(params)}`)
    }
  }, [history, params])

  const searchOrder = useCallback(() => {
    if (params) {
      setLoadingList(true)
      orderService.search(params, (data) => {
        setDataList(data)
        setLoadingList(false)
        setLoadingSearch(false)
      })
    }
  }, [params])

  const searchOrderPreLoad = useCallback(() => {
    if (params) {
      setLoadingList(false)
      orderService.search(params, (data) => {
        setDataList(data)
        setLoadingList(false)
        setLoadingSearch(false)
      })
    }
  }, [params])

  useEffect(() => {
    searchOrderPreLoad()
  }, [searchOrderPreLoad])

  return (
    <WrapperPage>
      <p className='title-page'>Theo dõi đơn vận</p>

      <FormWrapper>
        <FilterForm
          setParams={setParams}
          params={params}
          listSelectedOrder={listSelectedOrder}
          setListSelectedOrder={setListSelectedOrder}
          setLoadingSearch={setLoadingSearch}
          loadingSearch={loadingSearch}
        />

        <HistoryTable
          dataList={dataList}
          setParams={setParams}
          setListSelectedOrder={setListSelectedOrder}
          listSelectedOrder={listSelectedOrder}
          searchOrder={searchOrder}
        />
      </FormWrapper>
    </WrapperPage>
  )
}

export default Page
